type TertiaryButtonProps = {
  text: string; // Button text
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void; // Click handler
  size?: "big" | "medium" | "small" | "xsmall"; // Sizes
  color?: string; // Text color
  width?: string; // Width
  rounded?: string; // Rounded corners
  fontType?: string; // Font type
  padding?: string; // Custom padding (overrides default)
  className?: string; // Additional class names
  disabled?: boolean; // Disabled state
  testId?: string;
};

export const TertiaryButton: React.FC<TertiaryButtonProps> = ({
  text,
  onClick,
  size = "small", // Default to medium size
  color = "font-primary", // Default background color
  width = "w-full",
  rounded,
  fontType,
  padding,
  className = "",
  disabled = false,
  testId,
}) => {
  // Default padding for each size
  const defaultPadding = {
    big: "px-6 py-3",
    medium: "px-3 py-2",
    small: "px-2 py-1",
    xsmall: "px-2 py-1",
    xssmall: "px-1.5 py-1",
  };

  const sizeStyles = {
    big: `body-1-medium ${rounded ? rounded : "rounded-lg"} underline`,
    medium: `body-1-medium ${rounded ? rounded : "rounded-lg"} underline`,
    small: `body-2-medium ${rounded ? rounded : "rounded-lg"} underline`,
    xsmall: `body-3-medium ${rounded ? rounded : "rounded-md"} underline`,
    xssmall: `body-4-bold ${rounded ? rounded : "rounded-md"} underline`,
  };

  const buttonStyles = `
      ${padding || defaultPadding[size]}
      ${sizeStyles[size]} 
      ${color}
    `;

  return (
    <button
      style={{ fontFamily: fontType }}
      type="button"
      data-testid={testId}
      // `focus-ring`: the app's keyboard ring — without it the browser paints
      // its own dark default around the underlined text.
      className={`${className} transition-all duration-200 focus-ring ${buttonStyles} ${width} ${disabled ? "opacity-50 cursor-not-allowed" : "hover:opacity-70"}`}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
};
